/*
 * JuvaBun store quick fixes (Clarity W43, reports/2026-W43/clarity-store-quickfixes.md, Amit approved 2026-10-19 17:56).
 * Loaded sitewide from snippets/jb-head.liquid (defer). Vanilla, no requests on load, nothing runs until a tap.
 * Shared by every product page (jb-pdp = Messy Bun page and its JB37 variant, jb-pdp-gen = the other product pages),
 * so the Messy Bun control and the JB37 variant get exactly the same fixes.
 *  QF1 swatches: every swatch tap (also on the shade already selected) pulses the selected ring and the "Shade: X" line;
 *      if the main photo is above the screen, a "Showing <shade>" chip with a thumbnail appears and scrolls up to the
 *      photo on tap. Sold-out swatch: "Sold out in <shade>" + the 2 closest available shades (same row first) as buttons.
 *  v54 (SX-025, queue 231 b): a tap on the shade that is ALREADY picked gets the builder's BB-F6 answer: "Shade: X" line
 *      with a check and blush background and a ring on Add to cart for ~2.2 s, and the photo goes back to her shade.
 *  v54 (SX-024, queue 231 a): cart offer row (jb-c1b.js): a tap on the row photo or text = tap on its "Add it" button, same
 *      price, same code path and events, both C1 arms. Row that needs a shade first: the shade chips light up instead.
 *  v54 (SX-031, shared/open-items.md): cart Checkout buttons (.jbc-checkout, drawer and /cart) never leave while the cart is
 *      still changing. Tap during an update: the tap waits, /cart.js is re-read, then it goes on, or stops with a plain message
 *      when no real product is left (only Shipping Protection). Idle cart = the original tap, untouched, no request, no delay.
 *      The OCU pre-purchase popup still starts on the tap: see the block at the end of this file before changing it.
 *  QF4 home: customer review photos (.jb-rev__media img) open the photo viewer (assets/jb-lightbox.js, loaded on home).
 *  QF5 reviews: "From N verified reviews" in the reviews section jumps to the full review list (Loox list when open).
 *  QF7 cart: "What's this?" next to Shipping protection in the summary (markup in snippets/cart-jb-body.liquid, toggle in
 *      snippets/jb-head.liquid).
 * Tracking (Intelligems, selectors only): [data-jbq-chip], [data-jbq-alt], [data-jbq-allrev], [data-jbc-prot-info].
 */
(() => {
  if (window.__jbQuickfix) return;
  window.__jbQuickfix = true;

  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pulse = (el) => {
    if (!el) return;
    el.classList.remove('jbq-pulse');
    void el.offsetWidth; // restart the animation
    el.classList.add('jbq-pulse');
    clearTimeout(el._jbqT);
    el._jbqT = setTimeout(() => el.classList.remove('jbq-pulse'), 700);
  };
  // Tap on the already picked shade: say so, point at Add to cart, bring her shade's first photo back (no motion, Amit 10-19)
  const confirmShade = (pdp, line) => {
    const els = [line, pdp.querySelector('[data-atc]'), pdp.querySelector('[data-sticky-btn]')].filter(Boolean);
    els.forEach((el) => {
      el.classList.add('jbq-confirm');
      clearTimeout(el._jbqC);
      el._jbqC = setTimeout(() => el.classList.remove('jbq-confirm'), 2200);
    });
    if (pdp.slideIndex > 0 && typeof pdp.goTo === 'function') pdp.goTo(0);
  };
  const shadeName = (label) => {
    const sr = label.querySelector('.jb-sr');
    const t = (label.getAttribute('title') || (sr && sr.textContent) || '').replace(/\s*\((best seller|sold out)\)/gi, '');
    return t.split(',')[0].trim();
  };

  /* ------------------------------------------------------------------ QF1 */
  let chip = null;
  let chipT = 0;
  function hideChip() {
    if (!chip) return;
    chip.classList.remove('is-on');
    clearTimeout(chipT);
  }
  function showChip(pdp, label) {
    const gal = pdp.querySelector('.jb-gal');
    if (!gal) return;
    const r = gal.getBoundingClientRect();
    if (r.bottom > 80) { hideChip(); return; } // the photo is (partly) on screen: nothing to add
    if (!chip) {
      chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'jbq-chip';
      chip.setAttribute('data-jbq-chip', '');
      chip.innerHTML = '<span class="jbq-chip__img" aria-hidden="true"></span><span class="jbq-chip__txt"></span><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 15l6-6 6 6" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      chip.addEventListener('click', () => {
        hideChip();
        const g = chip._gal;
        if (g) g.scrollIntoView({ block: 'start', behavior: reduce() ? 'auto' : 'smooth' });
      });
      document.body.appendChild(chip);
    }
    chip._gal = gal;
    const img = label.querySelector('img');
    const box = chip.querySelector('.jbq-chip__img');
    box.style.backgroundImage = img ? `url("${(img.currentSrc || img.src).replace(/"/g, '%22')}")` : '';
    chip.querySelector('.jbq-chip__txt').textContent = `Showing ${shadeName(label)}`;
    chip.setAttribute('aria-label', `Showing ${shadeName(label)}. Scroll up to the photo`);
    requestAnimationFrame(() => chip.classList.add('is-on'));
    clearTimeout(chipT);
    chipT = setTimeout(hideChip, 4500);
  }

  function closeShades(label) {
    const avail = (root) => Array.from(root.querySelectorAll('.jb-shade:not(.is-soldout)'));
    const row = label.closest('.jb-fam__row') || label.parentElement;
    const all = Array.from(label.closest('.jb-fams, .jb-shades') ? label.closest('.jb-fams, .jb-shades').querySelectorAll('.jb-shade') : []);
    const at = all.indexOf(label);
    const byDist = (list) => list.sort((a, b) => Math.abs(all.indexOf(a) - at) - Math.abs(all.indexOf(b) - at));
    const out = byDist(avail(row));
    if (out.length < 2) byDist(avail(label.closest('.jb-fams, .jb-shades') || row)).forEach((x) => { if (!out.includes(x)) out.push(x); });
    return out.slice(0, 2);
  }
  function soldOut(pdp, label) {
    const fs = label.closest('.jb-shades') || pdp;
    let note = fs.querySelector('[data-jbq-sold]');
    if (!note) {
      note = document.createElement('div');
      note.className = 'jbq-sold';
      note.setAttribute('data-jbq-sold', '');
      note.setAttribute('role', 'status');
      const fams = fs.querySelector('.jb-fams');
      if (fams) fams.insertAdjacentElement('afterend', note); else fs.appendChild(note);
    }
    const alts = closeShades(label);
    note.innerHTML = '';
    const p = document.createElement('p');
    p.className = 'jbq-sold__txt';
    p.textContent = `Sold out in ${shadeName(label)}.${alts.length ? ' Close shades:' : ''}`;
    note.appendChild(p);
    alts.forEach((alt) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'jbq-sold__alt';
      b.setAttribute('data-jbq-alt', '');
      const im = alt.querySelector('img');
      b.innerHTML = `<span class="jbq-sold__sw" aria-hidden="true"${im ? ` style="background-image:url('${(im.currentSrc || im.src).replace(/'/g, '%27')}')"` : ''}></span><span></span>`;
      b.lastChild.textContent = shadeName(alt);
      b.addEventListener('click', () => {
        const input = alt.querySelector('input');
        note.hidden = true;
        if (input) input.click();
      });
      note.appendChild(b);
    });
    note.hidden = false;
  }

  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest) return;

    // Swatch on a product page (one event per tap: the label's click, not the input's echo)
    const label = t.closest('jb-pdp .jb-shade, jb-pdp-gen .jb-shade');
    if (label && t.tagName !== 'INPUT') {
      const pdp = label.closest('jb-pdp, jb-pdp-gen');
      if (label.classList.contains('is-soldout')) { soldOut(pdp, label); return; }
      const note = pdp.querySelector('[data-jbq-sold]');
      if (note) note.hidden = true;
      // The label's click runs before the browser's click on its input: checked here = she tapped the picked shade
      const inp = label.querySelector('input');
      const picked = !!(inp && inp.checked);
      // after the page script has applied the tap (photo, name)
      setTimeout(() => {
        pulse(label);
        const nm = pdp.querySelector('[data-shade-name]');
        const line = nm && (nm.closest('.jb-pdp__label') || nm);
        pulse(line);
        if (picked) confirmShade(pdp, line);
        showChip(pdp, label);
      }, 30);
      return;
    }

    // Cart offer row: photo and text act as the row's "Add it" button (the button itself and the chips keep their own taps)
    const rowBody = t.closest('[data-jbc1b] .jbc1b__in');
    if (rowBody) {
      const slot = rowBody.closest('[data-jbc1b]');
      const add = slot.querySelector('[data-jbc1b-add]');
      if (add && !add.disabled) { add.click(); return; }
      const chips = slot.querySelector('.jbc1b__chips');
      if (chips) {
        chips.classList.add('jbq-chips-hint');
        clearTimeout(chips._jbqT);
        chips._jbqT = setTimeout(() => chips.classList.remove('jbq-chips-hint'), 1800);
      }
      return;
    }

    // Home review photo -> photo viewer
    const rimg = t.closest('.jb-rev__media img');
    if (rimg && window.JBLightbox && typeof window.JBLightbox.open === 'function') {
      const all = Array.from(document.querySelectorAll('.jb-rev__media img'));
      const items = all.map((im) => ({ src: (im.currentSrc || im.src).replace(/([?&])width=\d+/, '$1width=1600'), alt: im.alt }));
      window.JBLightbox.open(items, Math.max(0, all.indexOf(rimg)), 'review');
      return;
    }

    // Reviews: "From N verified reviews" -> go to the full review list (the Loox list when it is open)
    const allRev = t.closest('[data-jbq-allrev]');
    if (allRev) {
      e.preventDefault();
      const root = allRev.closest('#jb-reviews') || document.getElementById('jb-reviews');
      const holder = root && root.querySelector('[data-loox-holder]');
      const list = root && root.querySelector('[data-rev-list]');
      const to = (holder && !holder.hidden && holder) || list || root;
      if (to) to.scrollIntoView({ block: 'start', behavior: reduce() ? 'auto' : 'smooth' });
      return;
    }
    // Cart "What's this?" ([data-jbc-prot-info]) is toggled by the existing handler in snippets/jb-head.liquid
  });

  window.addEventListener('scroll', () => { if (chip && chip.classList.contains('is-on') && chip._gal && chip._gal.getBoundingClientRect().bottom > 80) hideChip(); }, { passive: true });

  // "From N verified reviews" becomes a real tap target (the reviews section has no link there)
  const markReviews = () => {
    document.querySelectorAll('#jb-reviews .jb-pdp-rev__of').forEach((of) => {
      if (of.hasAttribute('data-jbq-allrev')) return;
      of.setAttribute('data-jbq-allrev', '');
      of.setAttribute('role', 'link');
      of.setAttribute('tabindex', '0');
      of.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); of.click(); } });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markReviews); else markReviews();

  /* ------------------------------------------------------------------ v54 SX-031 Checkout guard
     Why: Checkout is a plain form POST. Order #42418753 removed a bun and tapped Checkout 2.9 s later, while the cart queue and the
     jb-c1b.js twin guard (1.2 s delay) were still working, and the Shipping Protection line went through alone.
     Lives here, not in jb-cart.js / jb-c1b.js, so no file of a running cart test changes.
     OCU (Zipify pre-purchase) rules this block depends on, read from its script 2026-11-02:
     - OCU acts on BOTH touchend and click, capture phase, on window, so on a phone it runs before any click listener and may
       cancel the click. Which of our listeners runs first is not guaranteed, so we use its own switch window.OCUDisableEvents:
       the getter below answers true only for a tap on .jbc-checkout while the cart is unsettled, read at the moment of the event.
     - Settled cart: nothing is touched, OCU gets the real tap exactly as before.
     - Unsettled cart: we hold the click, wait, then button.click() with chk.pass set. An untrusted click still opens the popup on
       every template except "page" (OCU needs isTrusted there): on a page template that one tap goes to checkout with no popup.
     Builder: its button redirects to /discount/...?redirect=/checkout, it is not .jbc-checkout and never reaches this code. */
  const CHK = '.jbc-checkout';
  const CHK_MAX_WAIT = 8000;
  const CHK_TWIN_QUIET = 1500; // jb-c1b.js guard waits 1.2 s after a render, then swaps the twin through the queue
  const CHK_MSG = 'Your cart has no products left. Add one to check out.';
  const chk = { active: 0, doneAt: 0, waiting: false, pass: false };
  const isProtLine = (i) => !!i && (i.product_title === 'Shipping Protection' || /^shipping-protection/.test(String(i.handle || '')));
  const hasReal = (cart) => !!cart && (cart.items || []).some((i) => !isProtLine(i) && Number(i.quantity) > 0);
  const hasTwin = (cart) => !!cart && (cart.items || []).some((i) => i.properties && i.properties._jb_c1b);
  const wait = (ms) => new Promise((r) => setTimeout(r, ms));
  const cartBusy = () => {
    const J = window.JBCart;
    if (!J || !J.store || !J.net) return false;
    if (J.store.pending && J.store.pending.size) return true;
    if (chk.active > 0) return true;
    return hasTwin(J.net.lastCart) && Date.now() - chk.doneAt < CHK_TWIN_QUIET;
  };
  const needsHold = (btn) => {
    const J = window.JBCart;
    if (!J || !J.store || !J.net) return false;
    if (cartBusy()) return true;
    const root = btn.closest('[data-real-count]');
    if (root && (parseInt(root.dataset.realCount, 10) || 0) === 0) return true; // she just removed the last piece
    return !!J.net.lastCart && !hasReal(J.net.lastCart);
  };
  const track = (result) => { try { if (window.posthog && window.posthog.capture) window.posthog.capture('jb_checkout_guard', { result }); } catch (e) { /* never block */ } };
  const hold = (e) => { e.preventDefault(); e.stopImmediatePropagation(); };
  const markWait = (btn, on) => {
    if (!btn) return;
    btn.classList.toggle('jbq-wait', on);
    if (on) btn.setAttribute('aria-busy', 'true'); else btn.removeAttribute('aria-busy');
  };
  const runHold = async (btn) => {
    const J = window.JBCart;
    const formId = btn.form && btn.form.id;
    // The cart re-renders while she waits, so the button is looked up again every time
    const current = () => (formId && document.getElementById(formId) && document.getElementById(formId).querySelector(CHK)) || (document.contains(btn) ? btn : null);
    chk.waiting = true;
    let cart = null;
    try {
      const end = Date.now() + CHK_MAX_WAIT;
      markWait(current(), true);
      while (cartBusy() && Date.now() < end) { await wait(120); markWait(current(), true); }
      cart = await J.net.enqueue(() => J.net.getCart(6000));
    } catch (e) { cart = null; }
    chk.waiting = false;
    const now = current();
    markWait(now, false);
    const root = now && now.closest('[data-real-count]');
    const stop = cart ? !hasReal(cart) : (!now || (root && (parseInt(root.dataset.realCount, 10) || 0) === 0));
    if (stop || !now) {
      // refresh paints the empty cart; its reconcile takes the leftover protection line out
      J.store.showError(CHK_MSG);
      J.store.refresh();
      track('stopped');
      return;
    }
    track(cart ? 'waited' : 'waited_no_read');
    chk.pass = true;
    try { now.click(); } finally { chk.pass = false; }
  };
  const hookQueue = () => {
    const net = window.JBCart && window.JBCart.net;
    if (!net || net.__jbqHooked) return;
    net.__jbqHooked = true;
    const enqueue = net.enqueue;
    net.enqueue = function (task) {
      chk.active += 1;
      const p = enqueue.call(this, task);
      const end = () => { chk.active -= 1; chk.doneAt = Date.now(); };
      p.then(end, end);
      return p;
    };
  };
  // jb-cart.js is a deferred script in the body, so it runs after this file: DOMContentLoaded comes after all of them
  hookQueue();
  document.addEventListener('DOMContentLoaded', hookQueue);
  window.addEventListener('load', hookQueue);

  let ocuOff = window.OCUDisableEvents; // OCU sets this itself in a few flows: keep its value
  try {
    Object.defineProperty(window, 'OCUDisableEvents', {
      configurable: true,
      get() {
        if (ocuOff) return ocuOff;
        if (chk.pass) return false;
        const t = window.event && window.event.target;
        const btn = t && t.closest && t.closest(CHK);
        return !!btn && (chk.waiting || needsHold(btn));
      },
      set(v) { ocuOff = v; }
    });
  } catch (e) { /* OCU keeps working; the hold below still stops the click */ }

  window.addEventListener('click', (e) => {
    if (chk.pass) return;
    const t = e.target;
    const btn = t && t.closest && t.closest(CHK);
    if (!btn) return;
    if (chk.waiting) { hold(e); return; }
    if (!needsHold(btn)) return;
    hold(e);
    runHold(btn);
  }, true);
  // Enter key or a script submit, no tap on the button
  window.addEventListener('submit', (e) => {
    if (chk.pass) return;
    const f = e.target;
    const btn = f && f.matches && f.matches('.jbc-checkout-form') && f.querySelector(CHK);
    if (!btn) return;
    if (chk.waiting) { hold(e); return; }
    if (!needsHold(btn)) return;
    hold(e);
    runHold(btn);
  }, true);
  window.addEventListener('pageshow', (e) => { if (e.persisted) { chk.waiting = false; chk.pass = false; } });
})();
